<template>
  <article class="base-modal">
    <div class="option-counter">
      <div class="option-counter__header">
        <div class="header-group-name">{{ groupName }}</div>
        <div class="header-max-qty">
          {{ t('label.option_max_count', [maxCount]) }}
        </div>
      </div>
      <div class="option-counter__main">
        <div class="main__option-name">
          <span>{{ getNameByLocale(topping) }}</span>
          <span v-if="totalPrice > 0" class="option-name__price"> (+{{ formatCurrency(totalPrice) }})</span>
        </div>
        <div class="main__counter">
          <BaseCounter v-model="qty" :max="maxCount"></BaseCounter>
        </div>
      </div>
      <div class="option-counter__footer">
        <BaseButtonGroup>
          <BaseButton :flex="1" class="outline" @button-click="handleCloseButtonClick">{{
            t('button.close')
          }}</BaseButton>
          <BaseButton :flex="2" @button-click="handleAddButtonClick">{{ t('button.topping_add') }}</BaseButton>
        </BaseButtonGroup>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
  import BaseButton from '@/components/base/BaseButton.vue';
  import BaseButtonGroup from '@/components/base/BaseButtonGroup.vue';
  import BaseCounter from '@/components/base/BaseCounter.vue';
  import Topping from '@/interfaces/Topping';
  import { useModalStore } from '@/stores/modal';
  import { formatCurrency, getNameByLocale } from '@/utils';
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  const props = defineProps<{
    /** 토핑 그룹 이름 */
    groupName: string;
    /** 토핑 그룹에서 선택 가능한 수량 */
    groupSelectableQty: number;
    /** 토핑 데이터 */
    topping: Topping;
  }>();

  const { t } = useI18n();
  const modalStore = useModalStore();

  // 선택한 수량
  const qty = ref(1);

  // 최대 선택 가능 수량
  const maxCount = computed(() =>
    props.groupSelectableQty > props.topping.MaxCount ? props.topping.MaxCount : props.groupSelectableQty,
  );

  // 총 추가 가격
  const totalPrice = computed(() => props.topping.AddPrice * qty.value);

  /** 닫기 버튼 클릭 */
  const handleCloseButtonClick = () => modalStore.resolveSyncModal<number>(0);

  /** 추가 버튼 클릭 */
  const handleAddButtonClick = () => modalStore.resolveSyncModal<number>(qty.value);
</script>

<style lang="scss" scope>
  @use '@/assets/scss/variables' as vars;

  .base-modal {
    z-index: vars.$z-index-sync-modal;
  }

  .option-counter {
    display: grid;
    gap: 1.4925vw;
    border-radius: 0.5224vw;
    width: 59.7015vw;
    padding: 1.4925vw;
    background-color: #f3efef;

    .option-counter__header {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 1.4925vw;
      align-items: center;

      .header-group-name {
        font-size: 1.8657vw;
        @media (max-width: vars.$sm) {
          font-size: 22px;
        }
      }
      .header-max-qty {
        border-radius: 1.1194vw;
        padding: 0.7463vw 1.4925vw;
        background-color: var(--brand-primary);
        color: #fff;
        font-size: 1.4925vw;
        @media (max-width: vars.$sm) {
          font-size: 16px;
        }
      }
    }

    .option-counter__main {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 1.4925vw;
      align-items: center;
      border-radius: 0.5224vw;
      padding: 1.4925vw;
      background-color: #fff;

      .main__option-name {
        font-size: 1.7164vw;
        @media (max-width: vars.$sm) {
          font-size: 18px;
        }
      }
      .option-name__price {
        color: red;
      }
    }
  }
</style>
